<template>
  <div class="flex items-center justify-center">
    <VueApexCharts
      type="pie"
      :options="{
        chartOptions,
        labels: labels,
        colors: colors,
        legend: {
          show: true,
          showForSingleSeries: false,
          showForNullSeries: true,
          showForZeroSeries: true,
          position: 'bottom',
          horizontalAlign: 'center',
          itemMargin: {
            horizontal: 5,
            vertical: 0,
          },
        },
      }"
      :series="series"
      width=" 300"
    ></VueApexCharts>
  </div>
</template>
<script>
import VueApexCharts from 'vue-apexcharts'
export default {
  props: {
    summary: {
      type: Array,
      required: false,
    },
  },
  data() {
    return {
      drivers: [],
      vehicle: [],
      colors: [],
      width: 340,
      series: [],
      labels: [],
      chartOptions: {
        chart: {
          width: 380,
          type: 'pie',
          locales: ['fa'],
          defaultLocale: 'fa',
          type: 'line',
          id: 'areachart-2',
          fontFamily: 'Vazir',
        },

        responsive: [
          {
            breakpoint: 480,
            options: {
              chart: {
                width: 200,
              },
              legend: {
                position: 'bottom',
              },
            },
          },
        ],
      },
    }
  },
  watch: {
    summary(val) {
      val.map((data) =>
        this.labels.push(
          this.$i18n.locale == 'fa' ? data.fa_title : data.en_title
        )
      )
      val.map((data) => this.series.push(data.count))
      val.map((data) => this.colors.push(data.color.code))
    },
  },
  components: {
    VueApexCharts,
  },
}
</script>
